export default function sendData(data) {
  return fetch('https://wedding-server.hoa.ro/rsvp', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  });
}